import { render, staticRenderFns } from "./UploadImageComponent.vue?vue&type=template&id=bea0e5fc"
import script from "./UploadImageComponent.vue?vue&type=script&lang=js"
export * from "./UploadImageComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadImageComponent.vue?vue&type=style&index=0&id=bea0e5fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports